import { Component, Input } from '@angular/core';
import { ReadValue } from '@dasch-swiss/dsp-js';

@Component({
  selector: 'dsp-confirmation-message',
  templateUrl: './confirmation-message.component.html',
  styleUrls: ['./confirmation-message.component.scss']
})
export class ConfirmationMessageComponent {

    @Input() value: ReadValue;
    comment?: string;

    constructor() { }

    onKey(event: KeyboardEvent) {
        this.comment = (event.target as HTMLInputElement).value;
    }

}
